// src/components/principal/ParentInvite.jsx
import React, { useEffect, useState } from "react";
import api from "../../services/api";

const ParentInvite = ({ onError, loading: loadingProp }) => {
  const [inviteCode, setInviteCode] = useState("");
  const [loadingInvite, setLoadingInvite] = useState(false);

  const [parentAccounts, setParentAccounts] = useState([]);
  const [parentsLoading, setParentsLoading] = useState(false);

  const generate = async () => {
    setLoadingInvite(true);
    try {
      const { data } = await api.post("/auth/generate-parent-invite", {});
      setInviteCode(data.invite_code);
    } catch (e) {
      console.error(e);
      onError?.("Failed to generate invite code. Please try again.");
    } finally {
      setLoadingInvite(false);
    }
  };

  const copyLink = () => {
    const link = `https://ghrianghraffy.com/parent-signup?code=${inviteCode}`;
    navigator.clipboard
      .writeText(link)
      .catch(() => onError?.("Failed to copy invite link."));
  };

  const fetchParents = async () => {
    setParentsLoading(true);
    try {
      // 🔗 matches backend: @router.get("/parent-accounts", ...)
      const { data } = await api.get("/auth/parent-accounts");
      setParentAccounts(data || []);
    } catch (e) {
      console.error(e);
      onError?.("Failed to load registered parent accounts.");
    } finally {
      setParentsLoading(false);
    }
  };

  useEffect(() => {
    fetchParents();
  }, []);

  return (
    <div className="parents-content">
      {/* Invite code section */}
      <h3>Parent Invite Code</h3>
      <button
        onClick={generate}
        disabled={loadingInvite || loadingProp}
      >
        Generate Invite Code for Parents
      </button>

      {inviteCode && (
        <div className="invite-code-display">
          <p>
            Send parents this link:{" "}
            <a
              href={`https://ghrianghraffy.com/parent-signup?code=${inviteCode}`}
              target="_blank"
              rel="noopener noreferrer"
              className="template-download-link"
            >
              https://ghrianghraffy.com/parent-signup?code={inviteCode}
            </a>
            <button onClick={copyLink} className="copy-button">
              Copy Link
            </button>
          </p>
        </div>
      )}

      <hr />

      {/* Registered parent accounts section */}
      <h3>Registered Parent Accounts</h3>

      {parentsLoading ? (
        <p>Loading parent accounts…</p>
      ) : parentAccounts.length === 0 ? (
        <p>No parent accounts have been created yet.</p>
      ) : (
        <div className="parent-accounts-wrapper">
          <ul className="parent-accounts-list">
            {parentAccounts.map((p, idx) => (
              <li key={p.email || idx}>
                <strong>{p.email}</strong>
                {p.display_name ? ` — ${p.display_name}` : ""}
                {p.created_at_iso && (
                  <span className="parent-created-at">
                    {" "}
                    (joined {new Date(p.created_at_iso).toLocaleDateString()})
                  </span>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}

      <button
        type="button"
        onClick={fetchParents}
        disabled={parentsLoading}
        className="refresh-parents-button"
      >
        Refresh List
      </button>
    </div>
  );
};

export default ParentInvite;


